/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonArticle,
    JsonArticleFromJSON,
    JsonArticleFromJSONTyped,
    JsonArticleToJSON,
} from './JsonArticle';

/**
 * 
 * @export
 * @interface ApiResultOfJsonArticle
 */
export interface ApiResultOfJsonArticle {
    /**
     * 
     * @type {JsonArticle}
     * @memberof ApiResultOfJsonArticle
     */
    data?: JsonArticle;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonArticle
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonArticle
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonArticle
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonArticle
     */
    result?: ApiResultOfJsonArticleResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonArticleResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonArticleFromJSON(json: any): ApiResultOfJsonArticle {
    return ApiResultOfJsonArticleFromJSONTyped(json, false);
}

export function ApiResultOfJsonArticleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonArticle {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonArticleFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonArticleToJSON(value?: ApiResultOfJsonArticle | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonArticleToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

